import { ScheduledPostTarget } from 'types'
import Styles from './IconWithStatus.module.scss'
import { ValidationResult } from '../ScheduledPostTargetPreviewItem'
import { AlertTriangle, Check2 } from 'blaze-ui/icons'
import cx from 'classnames'

type Props = {
    providerIcon: React.ReactNode
    target?: ScheduledPostTarget
    validation: ValidationResult
    needsReauth: boolean
}

export const IconWithStatus = (props: Props) => {
    const { providerIcon, target, validation, needsReauth } = props

    return (
        <div className={Styles.iconWithStatus}>
        {providerIcon}
        {(target?.status === 'failed' ||
          !validation.isValid ||
          target?.status === 'published' ||
          needsReauth) && (
          <div
            className={cx(Styles.alertOverlay, {
              [Styles.errorOverlay]: target?.status === 'failed',
              [Styles.reauthOverlay]:
                needsReauth && target?.status !== 'failed' && target?.status !== 'published',
              [Styles.warningOverlay]:
                !validation.isValid &&
                target?.status !== 'failed' &&
                target?.status !== 'published' &&
                !needsReauth,
              [Styles.successOverlay]: target?.status === 'published',
            })}
          >
            {target?.status === 'published' ? (
              <Check2 color="var(--light-100)" size={12} />
            ) : (
              <AlertTriangle
                color={target?.status === 'failed' || needsReauth ? 'var(--light-100)' : 'var(--dark-80)'}
                size={12}
              />
            )}
          </div>
        )}
      </div>
    )
}